import createIcon from '../../createIcon';

/**
 * @component @name Shuffle
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTAuNTkgOS4xN0w1LjQxIDRMNCA1LjQxTDkuMTcgMTAuNThMMTAuNTkgOS4xN1pNMTQuNSA0TDE2LjU0IDYuMDRMNCAxOC41OUw1LjQxIDIwTDE3Ljk2IDcuNDZMMjAgOS41VjRIMTQuNVpNMTQuODMgMTMuNDFMMTMuNDIgMTQuODJMMTYuNTUgMTcuOTVMMTQuNSAyMEgyMFYxNC41TDE3Ljk2IDE2LjU0TDE0LjgzIDEzLjQxWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Shuffle = createIcon('Shuffle', [
  [
    'path',
    {
      d: 'M10.59 9.17L5.41 4L4 5.41L9.17 10.58L10.59 9.17ZM14.5 4L16.54 6.04L4 18.59L5.41 20L17.96 7.46L20 9.5V4H14.5ZM14.83 13.41L13.42 14.82L16.55 17.95L14.5 20H20V14.5L17.96 16.54L14.83 13.41Z',
      key: '173fgf',
    },
  ],
]);

export default Shuffle;
